/**
 * Política de tratamiento de datos — IVISNK9 Inspector (Colombia, Ley 1581 de 2012).
 */

export const PRIVACY_SECTIONS_INSPECTOR = [
  {
    title: '1. Responsable del tratamiento',
    paragraphs: [
      'El responsable del tratamiento de los datos personales obtenidos a través de la aplicación IVISNK9 Inspector es IVISNK9, en adelante “IVISNK9” o “el Responsable”, conforme a la legislación colombiana aplicable, en particular la Ley 1581 de 2012 y el Decreto 1074 de 2015 (Sector Comercio, Industria y Turismo), en lo pertinente.',
      'Para efectos de este documento, el canal de contacto es: dictamenes@ivisnk9.co.',
    ],
  },
  {
    title: '2. Alcance de esta información',
    paragraphs: [
      'Este documento describe de forma general el tratamiento de datos personales y el uso de tecnologías en su navegador asociado al uso de la aplicación IVISNK9 Inspector. No sustituye políticas internas, manuales de funcionarios ni contratos laborales o comerciales que puedan aplicar.',
    ],
  },
  {
    title: '3. Datos y finalidades',
    paragraphs: [
      'Según las funciones de la aplicación, pueden tratarse datos identificativos y de contacto de usuarios autorizados, datos relacionados con vehículos e inspecciones, imágenes o metadatos asociados al servicio, y registros técnicos necesarios para la operación y la seguridad.',
      'Las finalidades incluyen: autenticación y control de acceso, ejecución de los procesos de inspección y dictamen, soporte operativo, trazabilidad de acciones, cumplimiento de obligaciones legales, y atención de requerimientos de autoridades cuando proceda legalmente.',
    ],
  },
  {
    title: '4. Tecnologías en el navegador (sesión)',
    paragraphs: [
      'Para mantener su sesión y permitir el funcionamiento de la aplicación, IVISNK9 Inspector utiliza almacenamiento en su navegador (por ejemplo localStorage) para conservar tokens de acceso, información de usuario necesaria para la sesión y, según el caso, preferencias locales como la orientación de visualización de fotografías en su dispositivo.',
      'En la versión actual no se utilizan cookies con fines de publicidad ni se integran, para ese fin, herramientas de medición de audiencia de terceros. Cualquier cambio relevante en este punto se reflejará en las actualizaciones de esta política publicadas en la aplicación.',
    ],
  },
  {
    title: '5. Derechos de los titulares',
    paragraphs: [
      'Como titular de datos personales, usted puede ejercer los derechos previstos en la Ley 1581 de 2012, entre otros: conocer, actualizar, rectificar y suprimir sus datos; solicitar prueba de la autorización cuando sea aplicable; ser informado sobre el uso de sus datos; presentar ante la Superintendencia de Industria y Comercio (SIC) quejas por infracciones; revocar la autorización y/o solicitar la supresión del dato cuando no exista un deber legal o contractual que impida eliminarlo, y acceder en forma gratuita a sus datos que hayan sido objeto de tratamiento.',
      'Las solicitudes podrán dirigirse al canal de contacto indicado en la sección 1, sin perjuicio de los requisitos formales que el Responsable defina para su correcta gestión.',
    ],
  },
  {
    title: '6. Autoridad de supervisión',
    paragraphs: [
      'Sin perjuicio de los canales internos de IVISNK9, puede presentar quejas ante la Superintendencia de Industria y Comercio (SIC), en su calidad de autoridad nacional de protección de datos personales en Colombia, conforme a la normativa vigente.',
    ],
  },
  {
    title: '7. Vigencia y actualizaciones',
    paragraphs: [
      'IVISNK9 podrá actualizar esta política para reflejar cambios en el tratamiento de datos, en la aplicación o en la normativa. Las versiones vigentes se publicarán en esta aplicación y surtirán efectos desde la fecha que en cada caso se indique, sin perjuicio de lo dispuesto por la ley.',
    ],
  },
];
